// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2IoRr","colMin":"styles_colMin__3Ldb5"};